import { render, staticRenderFns } from "./CookiesPopup.vue?vue&type=template&id=5500ad04&scoped=true&"
import script from "./CookiesPopup.vue?vue&type=script&lang=js&"
export * from "./CookiesPopup.vue?vue&type=script&lang=js&"
import style0 from "./CookiesPopup.vue?vue&type=style&index=0&id=5500ad04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5500ad04",
  null
  
)

export default component.exports